export default __webpack_public_path__ + "static/media/stake-more-bnb-cbd.38a6fd55.svg";